export const MARKING_DIALOG_LAYOUT = {
    totalWidth: 631,
    eventsModal: {
        totalWidth: 489,
    },
    whiteColumn: {
        width: 468,
        paddingRight: 13,
    },
    blueColumn: {
        paddingLeft: 18,
        contentWidth: 105,
        // pseudoPaddingRight: 20,
    },
}
